<dx-popup
    #deleteWorkflowPopup
    minWidth="150px"
    minHeight="70px"
    width="30%"
    height="20%"
    title="Delete AAP Workflow"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onDeleteWorkflowPopUpShown()"
    (onHidden)="onDeleteWorkflowPopUpClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col" class="delete-workflow-popup">
            <dxi-item baseSize="auto">Please provide a reason to delete the AAP Workflow #{{ workflowId }}</dxi-item>
            <dxi-item [ratio]="1">
                <div class="textarea-container">
                    <dx-text-area class="textarea-content" [(value)]="deleteWorkflowReason"></dx-text-area>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div class="popup-button-row-container">
                    <div class="left-container">
                        <dx-button
                            type="default"
                            text="Cancel"
                            [icon]="iconClose"
                            (onClick)="onDeleteWorkflowPopUpClose()"
                        ></dx-button>
                    </div>

                    <div class="right-container">
                        <dx-button
                            class="button-content"
                            type="danger"
                            text="Delete AAP Workflow"
                            [icon]="iconDelete"
                            (onClick)="onDeleteConfirmWorkflow()"
                        ></dx-button>

                        <dx-button
                            class="button-content"
                            type="danger"
                            text="Delete Bill Only"
                            [icon]="iconDelete"
                            [visible]="false"
                        ></dx-button>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<cc-message-box #deleteWorkflowMessageBox></cc-message-box>
